import React from "react";
import images from "../../images/index";
import "./Hero.css";
import { FaLinkedin, FaGithub } from "react-icons/fa";

const Hero = () => {
  return (
    <section id="home">
      <div className="hero-container">
        <div className="hero-bg"></div>
        <div className="hero-text">
          <h2>
            Software Developer
            <img src={images.wave} alt="hand" style={{position:"relative",top:10}} />
          </h2>
          <p>
            Hi, I'm Hrithik, Software Developer at Teleperformance.
          </p>
          <div className="social">
            <a href="https://linkedin.com/in/hrithikksingh" target="_blank">
              <FaLinkedin />
              <p>Linkedin</p>
            </a>
            <a href="https://github.com/hrithikksingh3" target="_blank">
              <FaGithub />
              <p>Github</p>
            </a>
          </div>
        </div>
        <div className="hero-img">
          <img src={images.developer} alt="img" style={{position:"relative" ,top:100}}/>
        </div>
      </div>
    </section>
  );
};

export default Hero;
